import { PermissionsScope } from '../../policies/policy.model'

export const BRAND_FRAGMENT = 'brand'
export const BRAND_SCOPE: PermissionsScope = 'brands'
